import { Component, OnInit } from '@angular/core';
import { AdminService, AuthService, CalendarService, ConditionService, DialogService, FieldService, FormulaService, MessagingService, MetadataService, ModalService, SessionService, TranslatorService } from '../../../services';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UscNoApptDatesDataTableAdapter } from './usc-no-appt-dates-adapter';
import { UscStoreHoursDataTableAdapter } from './usc-store-hours-adapter';
import { addHours } from 'date-fns';

@Component({
    selector: 'sn-usc-store-scheduling-setup',
    templateUrl: './usc-store-scheduling-setup.component.html',
    styleUrls: ['./usc-store-scheduling-setup.component.css']
})
export class UscStoreSchedulingSetupComponent implements OnInit {

    public view: string = this.uscStoreService.view_store_scheduling_setup;
    public store_hours_adapter: UscStoreHoursDataTableAdapter;
    public no_appt_dates_adapter: UscNoApptDatesDataTableAdapter;
    public avail_appt_slots_btn_class:string = 'hidden';
    public no_appt_dates_btn_class:string = 'hidden';
    public current_store:any;
    public selectedDate:Date;
    public error_msg:string;

    constructor(
        public conditionService: ConditionService,
        public translatorService: TranslatorService,
        public fieldService: FieldService,
        public metadataService: MetadataService,
        public formulaService: FormulaService,
        public uscStoreService: UscStoreService,
        public authService: AuthService,
        public calendarService: CalendarService,
        public ngbModal: NgbModal,
        public modalService: ModalService,
        public dialogService: DialogService,
        public sessionService: SessionService,
        public messagingService: MessagingService,
        public adminService: AdminService,
    ) { }

    ngOnInit() {
        var user = this.authService.getActive();

        this.store_hours_adapter = new UscStoreHoursDataTableAdapter(this.uscStoreService.view_store_hours_table, {
            'uscStoreService': this.uscStoreService,
            'conditionService': this.conditionService,
            'translatorService': this.translatorService,
            'fieldService': this.fieldService,
            'metadataService': this.metadataService,
            'formulaService': this.formulaService,
            'authService': this.authService,
            'calendarService': this.calendarService,
            'ngbModal': this.ngbModal,
            'modalService': this.modalService,
            'dialogService': this.dialogService,
            'sessionService': this.sessionService,
            'messagingService': this.messagingService,
            'adminService': this.adminService,
        }, user.team_ID);
        this.store_hours_adapter.root_css_class = 'store-hours';

        this.no_appt_dates_adapter = new UscNoApptDatesDataTableAdapter(this.uscStoreService.view_no_appt_dates_table, {
            'uscStoreService': this.uscStoreService,
            'conditionService': this.conditionService,
            'translatorService': this.translatorService,
            'fieldService': this.fieldService,
            'metadataService': this.metadataService,
            'formulaService': this.formulaService,
            'authService': this.authService,
            'calendarService': this.calendarService,
            'ngbModal': this.ngbModal,
            'modalService': this.modalService,
            'dialogService': this.dialogService,
            'sessionService': this.sessionService,
            'messagingService': this.messagingService,
            'adminService': this.adminService,
        }, user.team_ID);
        this.no_appt_dates_adapter.root_css_class = 'no-appt-dates';

        this.avail_appt_slots_btn_class = "selected";
        if (this.uscStoreService.isLeader()) {
            this.current_store = this.uscStoreService.getSvtStoreUserByScope();
            this.uscStoreService.svtCurrentStore.subscribe(s => {
                this.current_store = s;
                this.store_hours_adapter.initialize();
                this.no_appt_dates_adapter.initialize();
            })
        }

        // this.store_hours_adapter.initialize();
        // this.no_appt_dates_adapter.initialize();
    }

    showLoadingIcon() { return this.store_hours_adapter.showLoadingIcon() || this.no_appt_dates_adapter.showLoadingIcon(); }

    showAppointmentSlots() {
        this.avail_appt_slots_btn_class = "selected";
        this.no_appt_dates_btn_class = "hidden";
    }

    showNoAppointmentDates() {
        this.no_appt_dates_btn_class = "selected";
        this.avail_appt_slots_btn_class = "hidden";
    }

    isAppointmentSlotsSelected() { return this.avail_appt_slots_btn_class == "selected" }
    isNoAppointmentDatesSelected() { return this.no_appt_dates_btn_class == "selected" }

    showStoreInfo() {
        return this.uscStoreService.enabledStoreVisitLeaderView();
    }

    addNoApptDate() {
        var date = new Date(this.selectedDate);
        date = addHours(date, 10);  // add offset to work with timezone        
        var no_appt_date = { date: date, is_holiday: false, label: this.calendarService.getDateText(date, "DDDD, MMMM dd yyyy") };
        console.log(no_appt_date);
        this.error_msg = this.no_appt_dates_adapter.addNoApptDate(no_appt_date);
        this.selectedDate = null;
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store-scheduling/usc-store-scheduling-setup/usc-store-scheduling-setup.component.ts